require('es6-shim');
// require('apple-mapkit-js');

// Get IE or Edge browser version
var version = detectIE();

if (version === false) {
  // document.getElementById('result').innerHTML = '<s>IE/Edge</s>';
} else if (version >= 12) {
  // document.getElementById('result').innerHTML = 'Edge ' + version;
} else {
  window.location.replace('https://app.simplapp.io/ie.html');
  // document.getElementById('result').innerHTML = 'IE ' + version;
}

window.mapkit.init({
  authorizationCallback: function(done) {
    fetch('https://api.simplapp.io/api/token/appleMapKit/app.simplapp.io')
      .then(res => res.text())
      .then(done);
  },
  language: 'de',
});

fetch('https://api.simplapp.io/api/token/appleMapKit/app.simplapp.io')
  .then(res => res.text())
  .then(token => {
    window.appleMapsToken = token;
  });

// window.mapkit.init({
//   authorizationCallback: function(done) {
//     done("eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlI3NjRKNTc3SjQifQ.eyJpc3MiOiJUUFNNWThCODQ5IiwiaWF0IjoxNTc4OTE3NTM4LCJleHAiOjE2MTA0OTYwMDAsIm9yaWdpbiI6Imh0dHBzOi8vYXBwLnNpbXBsYXBwLmlvLyJ9.cFGtjj2bsAbT9ylTQFNBWwIemO-f9_mSXFsWmMhTCM7KQAEZD2y7QsgKb8L-4NeZpdWc20SE1eHsbV5BrbYGkQ");
//   },
//   language: "de",
// });

// add details to debug result
// document.getElementById('details').innerHTML = window.navigator.userAgent;

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

import React from 'react';
import ReactDOM from 'react-dom';
// import createBrowserHistory from 'history/lib/createBrowserHistory'
// import { useRouterHistory } from 'react-router'
// import { syncHistoryWithStore } from 'react-router-redux'
import { IntlProvider, addLocaleData } from 'react-intl';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
// import { persistStore, autoRehydrate } from 'redux-persist'
import injectTapEventPlugin from 'react-tap-event-plugin';
import createStore from './store/createStore';
import AppContainer from './containers/AppContainer';
import muiTheme from './helpers/muiTheme';

require('cssuseragent');

addLocaleData([...en, ...de]);
injectTapEventPlugin();

window.simplPreselection = {
  company: null,
  project: null,
  activity: null,
  person: null,
  staff: null,
  task: null,
  file: null,
  usAsBlueprint: false,
};

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.__INITIAL_STATE__;
const store = createStore(initialState);

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root');

let render = () => {
  const routes = require('./routes/index').default(store);

  ReactDOM.render(
    <IntlProvider locale="de">
      <MuiThemeProvider muiTheme={muiTheme}>
        <AppContainer store={store} routes={routes} />
      </MuiThemeProvider>
    </IntlProvider>,
    MOUNT_NODE,
  );
};

// This code is excluded from production bundle
if (__DEV__) {
  // eslint-disable-next-line no-undef
  if (module.hot) {
    // Development render functions
    const renderApp = render;
    const renderError = error => {
      const RedBox = require('redbox-react').default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    // Wrap render in try/catch
    render = () => {
      try {
        renderApp();
      } catch (error) {
        console.error(error);
        renderError(error);
      }
    };

    // Setup hot module replacement
    // eslint-disable-next-line no-undef
    module.hot.accept('./routes/index', () =>
      // eslint-disable-next-line no-undef
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      }),
    );
  }
} else {
  // window.Raven.config(
  //   'https://5af69de6ff484e01a9e21c5b71b68d06@sentry.io/181745',
  // ).install();
}

// ========================================================
// Go!
// ========================================================
render();



// WEBPACK FOOTER //
// ./src/main.js